/**
 * SignIn コンポーネント
 */
const sign_in = {
    title: 'Sign in',
    text01: 'Sign in to the service site with your registered email address and password.'
}

/**
 * TechnologicalDevelopment コンポーネント
 */
const technological_development = {
    title: 'Grasping trends in technological development'
}
const select = {
    title: 'Select research themes',
    text01: 'Find and select the themes you want to analyse.',
    tips01: 'While entering a theme, AI will suggest themes that are close to the input keywords.',
    tips02:
        'After selecting a theme, relevant themes will be shown to you, which is convenient when searching for similar themes.',
    tips03: `You can check all registered themes by category from the "Theme list" on the upper right.`
}
const grasp = {
    title: 'Grasping the trend of technological development from the theme overview',
    text01:
        '・Grasp the trend of technological development in the theme based on the number of patent applications, and confirm whether the theme is worth working on.',
    howToUse01:
        "Data for the most recent two years (because the application has not yet been published) may be lacking. Let's check the trend of the data excluding the last two years.",
    howToUse02: `Graphs showing "Time Series of Patent Applications" and "Time Series of Inventors" can be used to confirm whether the technology development trend is flat or rising.`,
    howToUse03: `"Time Series of Patent Applications by Applied Region" and "Time Series of Patents Applications by Applied Country (Organization)" allow you to check which countries and technologies are actively used and which matches the area in which your company is operating.`,
    howToUse04: `You can check "Ratio of Patent Applications by Technology Classification (IPC)" and get a rough idea of which technologies can be most relevant when working on a theme.`
}

/**
 * ValueProvided コンポーネント
 */
const value_provided = {
    title: 'Hypothesis definition of the values proposed'
}
const specific = {
    title: 'Cluster & value chain analysis Identify technology developments that you want to pay attention to',
    text01: `We dig deep into technology trends from "Cluster & Value Chain". First, we will identify a trending group of technologies (clusters) according to your analysis purpose.`,
    howToUse01: `"Cluster & Value Chain" are divided into four domains, and the domains to be checked vary depending on the purpose. Select a group of technologies in the domain you want to check according to your purpose`,
    howToUse02:
        'In the case of a new business development, it is recommended to check the clusters belonging to domain 2, as it is desirable to identify the technology groups that are likely to see technological advance and become technological trends in the future.',
    howToUse03: `When you select a bubble, you can check the technical contents included in the selected cluster from the "Cluster List" at the bottom of the screen. You can search for what kind of technologies exist for each domain.`,
    howToUse04: `If you want to identify the cluster you want to focus on from the "Cluster List", you can get hints by checking from the following viewpoints:`,
    howToUse05: '<Score>',
    howToUse06: `If you want to identify a cluster with a high technological progress (score), click "Score" in the "Cluster List" and sort the data in descending order, and you will see the cluster with the most technological progress.`,
    howToUse07: '<Growth Rate of Score>',
    howToUse08: `If you want to identify clusters with a high growth rate of technology, click on "Growth Rate of Score" in the "Cluster List" and sort the data in descending order, and you will see the clusters that have experienced the most rapid growth in technology in recent years.`,
    howToUse09: '<Market Expectation>',
    howToUse10: `If you want to identify clusters that get high attention in the market, click on "Market Expectation" in the "Cluster List" and sort the data in descending order, and you will see the clusters that get the most attention in the market.`,
    howToUse11: '<Growth Rate of Market Expectation>',
    howToUse12: `If you want to identify clusters with a high growth rate of market attention, click on "Growth Rate of Market Expectation" in the "Cluster List" and sort the data in descending order, and you will see the clusters that have experienced the most rapid increase in market attention in recent years.`,
    tips01: `If the bubble is small (large), you can enlarge it with the "+" button (shrink it with the "-" button).`,
    tips02: `You can change the display data, set the x-axis and y-axis, hide the zoom slider, etc. from "Configuration".`,
    tips03: `By moving the slider near the x-axis and y-axis of the bubble chart, you can narrow down the area of the axis to be displayed, and you can expand and check the area you want to see.`,
    tips04: `You can fix the label of the cluster information by pressing "Label Fix".`
}

/**
 * SpecificIssues コンポーネント
 */
const specific_issues = {
    title: 'Examining specific issues and solutions'
}
const analysis = {
    title: "Analysis of the company's technology status",
    text01:
        'You can confirm whether the focused technology group has an affinity with the technology owned by the company and the services it provides, and whether it is a technology that you want to work on.',
    howToUse01: 'Enter your company name on the inter-company analysis page.',
    howToUse02:
        "A list of technology groups (clusters) that include your company's (selected company's) technology within the theme will be displayed.",
    howToUse03:
        'If the score is displayed, it means that the company owns the technology, so confirm that it has the technology for the relevant cluster.',
    howToUse04:
        'The brighter the color, the higher the value, so you can objectively see the difference with your competitors.'
}

/**
 * AssumedTasks コンポーネント
 */
const assumed_tasks = {
    title: 'Search for customers who have assumed issues'
}
const analyze_technology = {
    title:
        'Analyze technology groups from the perspective of upstream and downstream companies and estimate customers and issues',
    text01:
        'In order to deepen your analysis, you can check the technology groups possessed by upstream, downstream, and competitor companies, and deepen our understanding of the assumed customers and issues. You can also identify the companies you want to mark as competitors.',
    howToUse01: 'If you have decided on a company you want to research',
    howToUse02: `By narrowing down and checking the competitors of the "Patent Owner" from the "List of Patent Applications in the Cluster", you can obtain a list of patents associated with the technology. (You can download it as a CSV file by clicking on the download icon in the upper right corner of the table. This is useful for narrowing down data.)`,
    howToUse03: `Check the details of the patent information published in other services (Google Patent, Espacenet, J-PlatPat, etc.) from the "Publication Number", and speculate on the surrounding target customers and issues.`,
    howToUse04: 'If you have not yet decided on a company you want to research',
    howToUse05:
        'After searching for the companies included in the cluster, you can guess the target customers and issues.',
    howToUse06: 'Here are two ways to find companies you want to pay attention to.',
    howToUse07: `Companies with high technological competitiveness: You can identify companies with the highest scores from "Cluster Details (Company)".`,
    howToUse08: `Companies with more core technologies within the cluster: You can identify the companies by sorting the "List of Patent Applications in the Cluster" in descending order of the "Factor Load Quantity" and checking the "Patent Owner".`
}
const create_list = {
    title:
        'Creating a long list of alliance and investment targets based on the financial and investment aspects of startups',
    text01:
        'You can create a long list of alliance and investment targets based on the financial and investment aspects of startups.',
    howToUse01: 'If you want to make the startup company list at once',
    howToUse02: `Select the cluster from the bubble chart or select the cluster from the cluster list and move to "Cluster Details (Company)".`,
    howToUse03: 'Click the download icon on the top right to download the CSV file.',
    howToUse04: `By opening the CSV file with software such as Excel and filtering only by "Startup = 1 (*)", you can create a long list of candidate startups.`,
    howToUse05: 'If you want to pick up and list startup companies that you are interested in',
    howToUse06: `Select a cluster from the bubble chart or select a cluster from the cluster list and move to "Cluster Details (Company)".`,
    howToUse07:
        'Search for startups that interest you. \nExample) Identify startup companies with large (small) minority investments, companies with high scores (technical competitiveness), etc.',
    howToUse08: `Click on the company name, check the company information, and if you are a candidate based on the financial situation and the information of the investor company, you can click "Add to Favorites" to record the company you have set your sights on.`,
    howToUse09: `Click the download icon on the upper right of "Cluster Details (Company)" to download the CSV file.`,
    howToUse10: `You can create a long list by opening the CSV file with software such as Excel and filtering only by "startup = 1 (*)" and the name of the company registered in your favorites.`,
    howToUse11: `* "1" means startup, "0" means not startup.`,
    tips01: `If you want to check startup companies on the screen, click "Startup" in the table to sort by single item in ascending or descending order. Sorting in descending order will allow startups to appear first.`,
    tips02:
        'You can sort by multiple items by pressing the Shift button and clicking each item name in the table at the same time.'
}

/**
 * Hypothesis コンポーネント
 */
const hypothesis = {
    title: 'Verification of hypothetical value proposition and solutions'
}
const grasp_technology = {
    title: 'Grasping technical fields with uniqueness and superiority through inter-company analysis with competitors',
    text01:
        "You can typically carry out this analysis when the company's position and the names of competitors are clarified. In the inter-company analysis, you confirm once again whether there is a cluster (technology group) in which your company has advantage.",
    text02:
        'Also, if there is a more prominent cluster, you can deepen your analysis while changing the target cluster.',
    howToUse01:
        'On the inter-company analysis page, select your company, alliance candidate companies, or competitors. (Up to 5 companies can be compared)',
    howToUse02:
        'The high score (technical competitiveness) is displayed in color-scale, so you can check again whether your company can work with a superiority.',
    howToUse03: `At the bottom of the screen, the "Technology Portfolio" is displayed, allowing you to overview each company's technology portfolio mapped in the overall technology trends using a bubble chart.`,
    howToUse04:
        'You can determine whether the field is one in which you can demonstrate your competitiveness even if a competitor has strengths, or whether it is in a field that does not overlap with the competitor by forming an alliance with a partner and complementing weaknesses.',
    howToUse05:
        'If the comparison shows that the competitor is superior and it is difficult to demonstrate uniqueness or company advantage, you will return to hypothesis definition of the value proposition and consider specific issues and solutions, and repeat the analysis.',
    howToUse06:
        "Additionally, if there is a more prominent cluster in which the company's strengths can be demonstrated, you can change the target cluster for analysis and repeat the analysis."
}
const create_report = {
    title: 'Create a report for business creation/commercialization',
    text01: `You can prepare a prominent cluster, customers and their issues, value proposed, long list, etc., and you need to create a report for business creation/commercialization. Intelligent Business Analytics provides useful functions when creating reports.`,
    howToUse01: 'Various graphs and patent data confirmed in the analysis process can be used for your reporting.',
    howToUse02: "Selected theme's overviews [chart] (reported as trends in technological development)",
    howToUse03: `"Cluster & Value Chain" bubble chart [chart] (showing prominent cluster's ID)`,
    howToUse04:
        'List of patent applications held by competitors, upstream, and downstream companies [CSV file] (Patent information of prominent clusters, potential customers, issues, and supporting value proposed)',
    howToUse05:
        "Comparison between companies (our company, competitors, alliance candidates) [Chart] (Backing up the company's superiority)",
    howToUse06: 'Long list of companies (e.g. startups) [CSV file]'
}

/**
 * Tips コンポーネント
 */
const tips = {
    title01: 'Common',
    title02: `Bubble Chart of ”Cluster & Value Chain"`,
    text01: {
        before: `You can "copy the graph" from the `,
        after: ` icon. (Reference slides 1-1, 1-2)`
    },
    text02: {
        before: `You can adjust the horizontal size of the graph by dragging `,
        after: ` icon. (Reference slides 1-1 and 1-2)`
    },
    text03: `If you turn on "Zoom Slider" from "Configuration", you can display a slider that can narrow down the x-axis and y-axis. You can focus on the area you want to report on and show the chart, so use it as needed.`,
    text04: `After turning on "Label Fix" from "Configuration", you can copy charts along with labels by clicking "Copy", which is convenient for reporting. (Reference slides 2-1 and 2-2)`,
    text05: `*If you turn on "Label Fix", you will not be able to select clusters, so turn it off during analysis.`
}

/**
 * Analysis コンポーネント
 */
const analysis_rd = {
    title: 'Analysis of the current situation'
}
const check_cluster = {
    title: `Confirming the targeted cluster through the "Inter-company Analysis"`,
    text01: `Compare the scores (technological competitiveness) of a particular company and your own company against the targeted cluster (technology group) of interest, and confirm your company's relative position.\nYou will grasp the elemental technologies that are unique to your company and have superiority over other companies. Also, if there are more promising clusters, you can deepen your analysis while changing the clusters to be checked`,
    howToUse01: `Select a specific company (competitor, partner candidate, etc.) that you want to compare with your own company on the ”Inter-company Analysis" page. (Up to 5 companies can be compared.)`,
    howToUse02:
        'Since the high score (technical competitiveness) is displayed in color-scale, you can check whether your company has an advantage in the cluster.',
    howToUse03:
        'If it is determined that the competitor is superior and it is difficult to demonstrate uniqueness or company advantage based on the comparison, you can replace the targeted cluster or consider exploring partner candidates.'
}
const check_portfolio = {
    title: 'Confirming "Technology Portfolio" in inter-company analysis.',
    text01:
        'You can compare the patents and technology information held by a specific company and your own company from a more comprehensive perspective, allowing for conducting positioning analysis of each company.'
}
const check_company = {
    title: 'Confirm patents and patent-holding companies in the targeted cluster',
    text01:
        'Clarify the specific technology elements in which your company can excel by examining the content of patents held by competitors, upstream companies, and downstream companies.',
    howToUse01: 'If you have already selected the company you want to research',
    howToUse02: `You can obtain a list of patents held by competing companies by narrowing down to "Patent Owner" from the "List of Patent Applications in the Cluster" (You can download it as a CSV file by clicking on the download icon in the upper right of the table. This is useful for narrowing down the data.)`,
    howToUse03:
        'You can check the details of publicly available patent information from other services (such as Google Patent, Espacenet, J-PlatPat, etc.) using the patent publication number, and make educated guesses about the target customers and issues in the surrounding area.',
    howToUse04: 'If you have not yet decided on a company you want to research',
    howToUse05:
        'You can explore the companies included in the cluster and make educated guesses about the target customers and issues. Here are two ways to find companies you want to focus on:',
    howToUse06: `Companies with high technical competitiveness: You can identify the company with the highest score from "Cluster Details (Companies)".`,
    howToUse07: `Companies with more central technology within the cluster: You can sort the factor loadings in the "List of Patent Applications in the Cluster" in descending order and then check the "Patent Owner" to identify them.`
}

/**
 * Selection コンポーネント
 */
const selection = {
    title: 'Development target selection'
}
const cluster_map = {
    title: 'Identify Targeted Clusters from Cluster Maps',
    text01: `Delve deeper into technology trends from "Cluster & Value Chain". First, identify the targeted technology groups (clusters) based on the purpose of the project.`,
    howToUse01: `"Cluster & Value Chain" are divided into four domains, and the domains to be checked vary depending on the purpose. Select a group of technologies in the domain you want to check according to your purpose.`,
    howToUse02:
        'If you are formulating an R&D strategy, it is recommended to check the technology in each domain and grasp the overall technological trends and trends of the theme.',
    howToUse03:
        'Then, extract the technology group (cluster) that should be focused on in each value chain based on the high Market Expectation and presence or absence of your own technology.',
    howToUse04: `When you select a bubble, you can check the technical contents included in the selected cluster from the "Cluster List" at the bottom of the screen. You can search for what kind of technologies exist for each domain.`,
    howToUse05: `If you want to identify the cluster you want to focus on from the "Cluster List", you can get hints by checking from the following viewpoints:`,
    howToUse06: '<Score>',
    howToUse07: `If you want to identify a cluster with a high technological progress (score), click "Score" in the "Cluster List" and sort the data in descending order, and you will see the cluster with the most technological progress.`,
    howToUse08: '<Growth Rate of Score>',
    howToUse09: `If you want to identify clusters with a high growth rate of technology, click on "Growth Rate of Score" in the "Cluster List" and sort the data in descending order, and you will see the clusters that have experienced the most rapid growth in technology in recent years.`,
    howToUse10: '<Market Expectation>',
    howToUse11: `If you want to identify clusters that get high attention in the market, click on "Market Expectation" in the "Cluster List" and sort the data in descending order, and you will see the clusters that get the most attention in the market.`,
    howToUse12: '<Growth Rate of Market Expectation>',
    howToUse13: `If you want to identify clusters with a high growth rate of market attention, click on "Growth Rate of Market Expectation" in the "Cluster List" and sort the data in descending order, and you will see the clusters that have experienced the most rapid increase in market attention in recent years.`,
    tips01: `If the bubble is small (large), you can enlarge it with the "+" button (shrink it with the "-" button).`,
    tips02: `You can change the display data, set the x-axis and y-axis, hide the zoom slider, etc. from "Configuration". `,
    tips03:
        'By moving the slider near the x-axis and y-axis of the bubble chart, you can narrow down the area of the axis to be displayed, and you can expand and check the area you want to see.',
    tips04: `You can fix the label of the cluster information by pressing "Label Fix".`
}
const company_info = {
    title: 'Check Company Information within Clusters and Estimate Customer Issues',
    text01:
        'Explore suppliers from upstream company information and customers from downstream company information to estimate issues.',
    text02:
        'Capture the potential of startups from a financial and investment perspective, and consider the possibilities of alliances and M&A.',
    howToUse01: 'To Estimate Customer Issues',
    howToUse02: `Select a cluster from the bubble chart or the cluster list and transition to "Cluster Details (Company)".`,
    howToUse03: `Click on the relevant company name to transition to the "Company Profile" page.`,
    howToUse04: `On the "Company Profile" page, grasp the general "Business Overview". If further investigation is necessary, transition to the company's website from "Website" of "General Information". Read the contents of the website and further estimate customers and issues.`,
    howToUse05: `On the "Company Profile" page you can download a list of patents that the company has applied for. By confirming the contents of the list, you can identify customers and issues.`,
    tips01:
        'You can sort by multiple columns by pressing the Shift button and clicking each item name in the table at the same time.'
}
const consider = {
    title: 'Consideration of Promising Alliances and M&A from a Financial and Investment Perspective for Startups',
    text01:
        'Capture the potential of startups from a financial and investment perspective, and consider the possibilities of alliances and M&A.',
    howToUse01: 'If you want to make the startup company list at once',
    howToUse02: `Select the cluster from the bubble chart or select the cluster from the cluster list and move to "Cluster Details (Company)". `,
    howToUse03: 'Click the download icon on the top right to download the CSV file.',
    howToUse04: `By opening the CSV file with software such as Excel and filtering only by "Startup = 1 (*)", you can create a long list of candidate startups.`,
    howToUse05: 'If you want to pick up and list startup companies that you are interested in',
    howToUse06: `Select a cluster from the bubble chart or select a cluster from the cluster list and move to "Cluster Details (Company)".`,
    howToUse07:
        'Search for startups that interest you. \nExample) Identify startup companies with large (small) minority investments, companies with high scores (technical competitiveness), etc.',
    howToUse08: `Click on the company name, check the company information, and if you are a candidate based on the financial situation and the information of the investor company, you can click "Add to Favorites" to record the company you have set your sights on.`,
    howToUse09: `Click the download icon on the upper right of "Cluster Details (Company)" to download the CSV file.`,
    howToUse10: `You can create a long list by opening the CSV file with software such as Excel and filtering only by "startup = 1 (*)" and the name of the company registered in your favorites.`,
    howToUse11: `* "1" means startup, "0" means not startup.`,
    tips01: `If you want to check startup companies on the screen, click "Startup" in the table to sort by single item in ascending or descending order. Sorting in descending order will allow startups to appear first.`,
    tips02:
        'You can sort by multiple columns by pressing the Shift button and clicking each item name in the table at the same time.'
}

/**
 * Decision コンポーネント
 */
const decision = {
    title: 'Establishment of R&D Strategy'
}
const feature_company = {
    title: `Identifying prominent companies through the "Time Series of Patent Applications in the Cluster"`,
    text01: `By tracking the "Time Series of Patent Applications in the Cluster" of specific companies, their technological development trends can be grasped.`,
    howToUse01: `Click on "Time Series of Patent Applications in the Cluster" when a cluster is selected from the bubble chart or the "Cluster List".`,
    howToUse02:
        'You can confirm the time series of patent application of the top 10 companies with the highest number of patent applications within the selected cluster.',
    howToUse03:
        "Please note that there may be insufficient data for the past 2 years due to the delay in publication of patent applications. Let's check the trend of the data except for the past 2 years.",
    howToUse04:
        'Based on the trends in the technology development of competitors, you can conjecture their technological development trends.',
    howToUse05:
        'You will repeatedly conduct current situation analysis and R&D strategy planning until the technologies to be tackled and those that need to be developed intensively become clear, and deepen your analysis.'
}
const create_report_rd = {
    title: 'Creating a report for R&D Strategy planning',
    text01:
        'By preparing promising clusters, customer issues, value propositions, long lists, and more, it is possible to create reports for business creation and commercialization. Intelligent Business Analytics provides useful features when creating reports.',
    howToUse01: `By preparing information such as the results of strengths and weaknesses analysis (Inter-company Analysis) with competitors, customer issues, value propositions, and long lists of potential alliances and more, it is possible to create reports for R&D strategy planning.
  The following information will be included in the report:
  1) An overview of the selected theme [chart] (reported as a trend in technology development)
  2) Inter-company Analysis (own company, competitors, and potential alliances) [chart] (supporting evidence for the company's superiority)
  3) List of patent applications held by competitors, upstream and downstream companies [CSV file] (supporting evidence for the patent information of the selected cluster and the assumed customer issues, value propositions)
  4) Bubble chart of the Cluster & Value Chain [chart] (displaying the selected Cluster ID)
  5) Long list of potential alliances (M&A) [CSV file].`
}

/**
 * EvaluationImprovement コンポーネント
 */
const evaluation_improvement = {
    title: 'Evaluation and Improvement'
}
const revision = {
    title: `Revision of R&D strategy based on the latest trends`,
    text01:
        'Every quarter or half-year, the R&D strategy can be revised based on the latest technology trends and the movements of competitors.'
}

/**
 * テキスト側での指定は
 * `newBusiness.${アンカーリンク}.xxxx`
 */
export const newBusiness = {
    pdf: 'Usecase document for new business development [PDF 376KB]',
    sign_in,
    technological_development,
    select,
    grasp,
    value_provided,
    specific,
    specific_issues,
    analysis,
    assumed_tasks,
    analyze_technology,
    create_list,
    hypothesis,
    grasp_technology,
    create_report,
    tips
}

/**
 * テキスト側での指定は
 * `strategyDevelopment.${アンカーリンク}.xxxx`
 */
export const strategyDevelopment = {
    pdf: 'Usecase document for R&D strategy planning [PDF 433KB]',
    sign_in_rd: sign_in,
    technological_development_rd: technological_development,
    select_rd: select,
    grasp_rd: grasp,
    analysis_rd,
    check_cluster,
    check_portfolio,
    check_company,
    selection,
    cluster_map,
    company_info,
    consider,
    decision,
    feature_company,
    create_report_rd,
    evaluation_improvement,
    revision,
    tips
}

export const howToUse = {
    title: 'How to use',
    description:
        'Introduces operation methods and analysis viewpoints in the main use cases of Intelligent Business Analytics.\nPlease check the necessary steps for your interested use cases.\nPlease note that the screens and data used in the explanation can be under development and may differ from the actual screens.',
    labelNewBusiness: 'New business development',
    labelStrategyDevelopment: 'R&D strategy formulation',
    Usecase: 'Usecase',
    howToUse: 'How to use'
}
